import 'owl.carousel';

function init() {

  const sliders = document.querySelectorAll('.c-partners');

  if (!sliders) {
    return;
  }

  PartnersCarousel();

}

/*
var fixOwl = function(){

  var stage = $('.owl-stage'),
      stageW = stage.width(),
      el = $('.owl-item a .item'),
      elW = 0;
  el.each(function() {
      var elRW = $(this).width();
      //.find(".item").find('.c-partners__image')
      console.log(elRW);
      el.closest(".owl-item").width(elRW);
  });

}*/

function PartnersCarousel() {

  $(document).ready(function($) {
    /*$('.partners-carousel').owlCarousel({
      items:1,
      loop:true,
      margin: 90,
      autowidth: true,
      dots: false,
      autoplay: true,
      slideTransition: 'linear',
      autoplaySpeed: 4000,
      autoplayTimeout: 4000,
      autoplayHoverPause: false,
      autowidth: true,
      responsiveClass:true,
      onInitialized: fixOwl,
      onRefreshed: fixOwl,
      responsive:{

        0:{

          stagePadding: 20,

        },
        768:{

          items: 2,

        },
        900:{

          items: 3,

        },
        1220:{

          items: 4,
          stagePadding: 100,

        }

      }

    }); */

    $('.featured-carousel').owlCarousel({
      items:1,
      loop:false,
      margin: 20,
      dots: false,
      autoplay: false,
      responsiveClass:true,
      responsive:{

        0:{

          center: true,
          mouseDrag: true,
          touchDrag: true,

        },
        700:{

          items: 3

        }

      }

    });

  });


}


export default init;
